import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { ChromePicker } from "react-color";
import { DialogActions } from "@mui/material";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { StyledModalRoot } from "../../styled/modal";
import { ButtonInfoNoShadow } from "../../styled/button";

const NeighborhoodGroupFormModal = ({ show, group, onSave, closeModal }) => {
  const [formData, setFormData] = useState({
    hex_color: "#000000",
    neighborhood: "",
    signal: [], // Changed to array
    ...group,
  });
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [newSignal, setNewSignal] = useState("");

  useEffect(() => {
    if (!show) return;

    setFormData({
      hex_color: "#000000",
      neighborhood: "",
      signal: [],
      ...group,
    });
    setNewSignal("");
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddSignal = () => {
    if (newSignal.trim()) {
      setFormData({
        ...formData,
        signal: [...formData.signal, newSignal.trim()],
      });
      setNewSignal("");
    }
  };

  const handleRemoveSignal = (signalToRemove) => {
    setFormData({
      ...formData,
      signal: formData.signal.filter((signal) => signal !== signalToRemove),
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddSignal();
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={closeModal}
      closeAfterTransition
      sx={{
        zIndex: 5000,
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show}>
        <StyledModalRoot overflow="auto">
          <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
            <TextField
              fullWidth
              margin="normal"
              label="Nome do Bairro"
              name="neighborhood"
              value={formData.neighborhood || ""}
              onChange={handleChange}
              required
            />

            <Box sx={{ mt: 2, mb: 1 }}>
              <TextField
                fullWidth
                label="Código"
                value={newSignal}
                onChange={(e) => setNewSignal(e.target.value)}
                onKeyPress={handleKeyPress}
                InputProps={{
                  endAdornment: (
                    <ButtonInfoNoShadow
                      sx={{ ml: 1 }}
                      variant="contained"
                      onClick={handleAddSignal}
                    >
                      Adicionar
                    </ButtonInfoNoShadow>
                  ),
                }}
              />
            </Box>

            <Stack
              direction="row"
              spacing={1}
              sx={{ flexWrap: "wrap", gap: 1, mb: 2 }}
            >
              {formData.signal.map((signal, index) => (
                <Chip
                  key={index}
                  label={signal}
                  onDelete={() => handleRemoveSignal(signal)}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Stack>

            <Box sx={{ my: 2 }}>
              <Button
                type="button"
                onClick={() => setShowColorPicker(!showColorPicker)}
                variant="outlined"
                sx={{ mb: 1 }}
              >
                Selecionar Cor
              </Button>
              {showColorPicker && (
                <Box sx={{ position: "absolute", zIndex: 2 }}>
                  <ChromePicker
                    color={formData.hex_color}
                    onChange={(color) =>
                      setFormData({
                        ...formData,
                        hex_color: color.hex,
                      })
                    }
                  />
                </Box>
              )}
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  backgroundColor: formData.hex_color,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                }}
              />
            </Box>

            <DialogActions>
              <Button onClick={closeModal}>Voltar</Button>
              <ButtonInfoNoShadow
                type="submit"
                variant="contained"
                color="primary"
              >
                {group ? "Atualizar" : "Criar"}
              </ButtonInfoNoShadow>
            </DialogActions>
          </Box>
        </StyledModalRoot>
      </Fade>
    </Modal>
  );
};

export default NeighborhoodGroupFormModal;
